module.exports = __webpack_public_path__ + "img/rakete-ahoi.66145daa.svg";